import queryString from 'query-string';

export type ConversationParamSpec = { parse(raw: string): string | null };

export const readConversationParams = (
  search: string,
  specs: Record<string, ConversationParamSpec>,
): Record<string, string> => {
  const parsed = queryString.parse(search);
  const result: Record<string, string> = {};
  Object.entries(specs).forEach(([key, spec]) => {
    const raw = parsed[key];
    if (typeof raw !== 'string') return;
    try {
      const value = spec.parse(raw);
      if (value !== null) result[key] = value;
    } catch {
      // An invalid URL value never prevents the remaining keys from loading.
    }
  });
  return result;
};

export const writeConversationParams = (
  search: string,
  patch: Record<string, string | null>,
): string => {
  const parsed = queryString.parse(search);
  Object.entries(patch).forEach(([key, value]) => {
    if (value === null) delete parsed[key];
    else parsed[key] = value;
  });
  const next = queryString.stringify(parsed);
  return next ? `?${next}` : '';
};
